import React, { Component } from "react";
import Product from "./components/product";
import HandHover from "./components/handHover";
import { getDashboardData } from "../services/dashboardServices";
import { connect } from "react-redux";
import "./style.css"
import 'bootstrap/dist/css/bootstrap.css'; 
import Layout from "./components/Layout";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'





class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      dashboardData: [],
      updateDashboardData: [],
      team: "xdr",
      showModal: false,
      dataLoaded: false,
      // profile: {}
    };
  }
  componentDidMount() {
    getDashboardData().then((json) => {
      this.setState({
        dashboardData: json,
        dataLoaded: true,

        
      });
    });
  }

  

  handleShow = () => {
    this.setState({ showModal: true });
  }

  handleClose = () => {
    this.setState({ showModal: false });
  }

  render() {
   
    const {dashboardData, dataLoaded} = this.state;

    

    return (
      <>
      <section className="dashboard">
      
       <Layout team="xdr">
              {this.state.team !== "handHover" ? (
                <div className="main-pannel white-gradient ">
          <div className="xdr-nav">
            <div className="xdr-info">
              <img src="images/invinsense_XDR_logo1.png" id="xdr-logo-1" alt="InvinSense XDR Logo" title="InvinSense XDR"/>
              <img src="images/invinsense_XDR_logo2.png" id="xdr-logo-2" alt="InvinSense XDR Logo" title="InvinSense XDR"/>
              <img src="images/invinsense_XDR_logo3.png" id="xdr-logo-3" alt="InvinSense XDR Logo" title="InvinSense XDR"/>
              <img src="images/invinsense_XDR_logo4.png" id="xdr-logo-4" alt="InvinSense XDR Logo" title="InvinSense XDR"/>
              <p id="xdr-para-1">The Defender's Brain of <br />your cybersecurity</p>
              <p id="xdr-para-2">The Attacker's Mind of your<br />cybersecurity</p>
              <p id="xdr-para-3">Improve your Detection and <br />Response with Attacker's Actions</p>
              <p id="xdr-para-4">An intutive platform for Governance,<br />Risk and Compliance</p>
            </div>
            { !this.state.showModal && <div className="xdr-architecture xdr-cursor" onClick={this.handleShow} >
              <div className="xdr-arc-icon">
                <img src="images/flow.png" alt="flow" title="xdr-flow" />
              </div>
              <p>View Architecture</p>
            </div>}
            { this.state.showModal && <div className="xdr-architecture close xdr-cursor" onClick={this.handleClose}>
              <div className="xdr-arc-icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              </div>
              <p>Close</p>
            </div>}
          </div>

          {/* <button onClick={this.toastShow}>toast</button> */}


          { this.state.showModal && <div className="justify-content-center d-flex"><img className="diagramImg" src="diagrams/Diagram-XDR.png" alt="Invinsense Extended Detection and Response(XDR) diagram"/></div>}
          <div className="w-layout-grid card-row-1" style={{transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)', transformStyle: "preserve-3d", opacity: "1", display: "grid"}}   id="xdr-row-1">

          { !this.state.showModal && (dataLoaded ? dashboardData?.map((tool) => {
              
               
             
              
              if( tool.gname === "xdr"){
                return  <Product color='blueBack' product={tool} /> || <Skeleton />;
              } 
            }): <div>
              <Skeleton height={273} borderRadius={"24px"}/> 
            </div>)} 
          </div>
        </div>
              ) : (
                <HandHover />
              )}
              </Layout>
        </section>


        

      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Dashboard);
